import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Template } from '../../Components/Template/template'
import {
    AlertType, classDivBackground, classInput, classLabel, classInputDark, classLabelDark, classbtAzul, classBt, classDivBody,
    contaAPagarAttributes, classBorderLabelDark, classWeigthBt, bgBlue, barraVermelhoAzul, bgRed,
    focusRed, focusLabelRed, classbtColunasVermelho, classbtCinzaClaro, classDtCriarAtt, classUserCriarAtt, InputsRefs,
    FornecedorSearchBox, GrupoDespesaSearchBox, SubGrupoDespesaSearchBox
} from '../../Utils/Types'
import { IoSave } from 'react-icons/io5'
import { FeedbackMessage } from '../../Components/FeedbackMessage/feedback-message'
import { SearchBox } from '../../Components/SearchBox/SearchBox'
import { ContaAPagarService } from './ContaAPagarService'
import { useParams } from 'react-router-dom'
import moment from 'moment'
import { BsBoxArrowInLeft } from 'react-icons/bs'
import { Link } from 'react-router-dom'
import { faClipboardList, faFolder } from '@fortawesome/free-solid-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { Icone } from '../../Components/Icones/Index'
import { Funcoes } from '../../Utils/Funcoes'
import { FcNook } from 'react-icons/fc'
import { FaRegQuestionCircle, FaVideo } from 'react-icons/fa'
import { Tooltip } from 'react-tooltip'
import { AiOutlineClear } from 'react-icons/ai'
import { ModalTutorial } from '../../Components/Modal/modal-tutorial'

export const LancamentoContaAPagar = () => {

    /*
    //const [windowHeight, setWindowHeight] = useState(0)
    // atributos auditoria 
    useEffect(() => {
        setWindowHeight(window.innerHeight - 64)
    }, [])
    */

    // ----------------- TABS --------------------------------------------------------   
    type Tab = {
        index: number,
        titulo: String,
        active: boolean,
        icon: IconProp,
    }

    const itabs: Tab[] = [
        { index: 0, titulo: 'Dados Principais', active: true, icon: faFolder },
        { index: 1, titulo: 'Auditoria', active: false, icon: faClipboardList },
    ]

    const [tabs, setTabs] = useState<Tab[]>(itabs)

    // ------------------ ATRIBUTOS ---------------------------------------------------
    const { idDupPagar } = useParams<string>()
    const [id, setId] = useState(0)
    const [attributes, setAttributes] = useState<contaAPagarAttributes>()

    const [numDoc, setNumDoc] = useState("")
    const [numDocCopia, setNumDocCopia] = useState("")
    const [serie, setSerie] = useState("")
    const [valor, setValor] = useState("")

    // FORNECEDOR
    const [idFornecedor, setIdFornecedor] = useState(0)
    const [fornecedorList, setFornecedorList] = useState<FornecedorSearchBox[]>([])
    const [fornecedor, setFornecedor] = useState<FornecedorSearchBox[]>([])

    // GRUPO DESPESA
    const [idGrupoDesp, setIdGrupoDesp] = useState(0)
    const [idSubGrupoDesp, setIdSubGrupoDesp] = useState(0)

    const [grupoDespList, setGrupoDespList] = useState<GrupoDespesaSearchBox[]>([])
    const [subGrupoDespList, setSubGrupoDespList] = useState<SubGrupoDespesaSearchBox[]>([])

    let dateI = moment().utcOffset('-03:00').format('YYYY-MM-DD')
    const [dtEmissao, setDtEmissao] = useState(dateI)
    const [dtVencimento, setDtVencimento] = useState("")
    const [observacao, setObservacao] = useState("")

    // ---------- ATRIBUTOS FEEDBACK -------------------------------------------------
    const [loading, setLoading] = useState(false)
    const [visible, setVisible] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("SUCCESS")

    // ---------- ATRIBUTOS AUDITORIA -------------------------------------------------
    const [userCriador, setUserCriador] = useState("")
    const [dtCriador, setDtCriador] = useState("")
    const [usertAtt, setUsertAtt] = useState("")
    const [dtAtt, setDtAtt] = useState("")

    // --------- SEARCHBOX ------------------------------------------------------------
    const [visibleSearchBoxFornecedor, setVisibleSearchBoxFornecedor] = useState<boolean>(false)
    const [visibleSearchBoxGrupoDespesa, setVisibleSearchBoxGrupoDespesa] = useState<boolean>(false)
    const [visibleSearchBoxSubGrupoDespesa, setVisibleSearchBoxSubGrupoDespesa] = useState<boolean>(false)

    // ---------- ATRIBUTOS TUTORIAL --------------------------------------------------
    const [modalTutorialVisible, setModalTutorialVisible] = useState(false)

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- ATRIBUTOS E EFFECT --------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const getAttributes = async () => {

        setVisible(false)
        setLoading(true)

        try {

            const Attributes = await ContaAPagarService.GetAttributes(idDupPagar)

            const ForneList = Attributes.data.fornecedor.filter((item: any) => item.id === Attributes.data.contaAPagar?.id_fornecedor)
            if (ForneList && ForneList.length > 0) {
                setIdFornecedor(ForneList[0].id)
            }

            const GDespList = Attributes.data.grupoDespesa.filter((item: any) => item.id === Attributes.data.contaAPagar?.id_grupo_despesa)
            if (GDespList && GDespList.length > 0) {
                setIdGrupoDesp(GDespList[0].id)
            }

            const SGDespList = Attributes.data.subGrupoDespesa.filter((item: any) => item.id === Attributes.data.contaAPagar?.id_sgrupo_despesa)
            if (SGDespList && SGDespList.length > 0) {
                setIdSubGrupoDesp(SGDespList[0].id)
            }

            setAttributes(Attributes.data)

            if (Attributes && idDupPagar) {

                setId(Attributes.data.contaAPagar.id || 0)
                setSerie(Attributes.data.contaAPagar.serie?.toString() || '')
                setDtEmissao(moment(Attributes.data.contaAPagar.dt_cadastro).format('YYYY-MM-DD') || '')
                setDtVencimento(Attributes.data.contaAPagar.dt_vencimento || '')
                setNumDoc(Attributes.data.contaAPagar.num_doc || '')
                setNumDocCopia(Attributes.data.contaAPagar.num_doc || '')
                setValor(Attributes.data.contaAPagar.valor.toString() || '')
                setObservacao(Attributes.data.contaAPagar.observacao || '')

                if (Attributes.data.contaAPagar?.dt_cadastro) {
                    const dataFormatadaCriacao = moment(Attributes.data.contaAPagar?.dt_cadastro).format('DD/MM/YYYY HH:mm')
                    setDtCriador(dataFormatadaCriacao)
                }

                if (Attributes.data.contaAPagar?.dt_last_update) {
                    const dataFormatadaAtt = moment(Attributes.data.contaAPagar?.dt_last_update).format('DD/MM/YYYY HH:mm')
                    setDtAtt(dataFormatadaAtt)
                }

                setUserCriador(Attributes.data.contaAPagar?.name_user_insert || '')
                setUsertAtt(Attributes.data.contaAPagar?.name_user_last_update || '')
            }

            if (Attributes) {
                setGrupoDespList([...Attributes.data.grupoDespesa])
                setSubGrupoDespList([...Attributes.data.subGrupoDespesa])
                setFornecedorList([...Attributes.data.fornecedor])
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage("Não foi possível carregar os dados")

        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getAttributes()
    }, [])

    /*
    useEffect(() => {
        if (idGrupoDesp === 0) {
            setIdSubGrupoDesp(0)
        } else {

            if (Attributes) {
                let newGrupoDespesaList = [...Attributes.grupoDespesa || []]
                let newSGrupoDespesaList = [...Attributes.subGrupoDespesa || []]

                newGrupoDespesaList = newGrupoDespesaList.filter(item => item.id === idGrupoDesp)

                if (Attributes.subGrupoDespesa) {
                    newSGrupoDespesaList = Attributes.subGrupoDespesa?.filter(item => item.id === newGrupoDespesaList[0].id_sgrupo_despesa)
                    setIdSubGrupoDesp(newSGrupoDespesaList[0].id)
                }

            }

        }
    }, [idGrupoDesp])
    */

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement;
        if (target instanceof HTMLAnchorElement) {
            target.blur();
        }

        Inputfocus()
    }, [])

    const handleChangeTab = async (tab: number) => {
        let newTabs = await tabs.map((item) => {
            if (item.index === tab) {
                itabs[item.index].active = true
            } else {
                itabs[item.index].active = false
            }
            return itabs[item.index]
        })
        setTabs(newTabs)
        handleInputFocus()
    }

    useEffect(() => {

        if (tabs[0].active) {
            Inputfocus()
        }

    }, [tabs])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- INPUTS --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleChangeNumDoc = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNumDoc(e.target.value)
    }

    const handleChangeSerie = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSerie(e.target.value.replace(/[^0-9]/g, ''))
    }

    const handleChangeValor = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValor(Funcoes.MaskMoney(e.target.value))
    }

    const handleChangeDtEmissao = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDtEmissao(e.target.value)
    }

    const handleChangeDtVencimento = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDtVencimento(e.target.value)
    }

    const handleChangeObs = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setObservacao(e.target.value)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- FORNECEDORES --------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearFornecedorSelecionada = useCallback(() => {
        const newFornList = [...attributes?.fornecedor || []]
        setFornecedorList(newFornList)
        setIdFornecedor(0)

        setVisibleSearchBoxFornecedor(false)
        boxFocusFornecedor()
    }, [attributes?.fornecedor])

    const handleFilterFornecedorClick = useCallback(async (description: string) => {

        if (description === "") {

            const newFornList = [...attributes?.fornecedor || []]
            setFornecedorList(newFornList || [])

        } else {

            const newFornList = [...attributes?.fornecedor || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setFornecedorList(newFornList || [])
        }

    }, [attributes?.fornecedor])

    const handleFornecedorSelectClick = useCallback((v: FornecedorSearchBox) => {

        if (v) {
            const newFornList = [...attributes?.fornecedor || []]
            setFornecedorList(newFornList)
            setIdFornecedor(v.id)
        }

        setVisibleSearchBoxFornecedor(false)
        boxFocusFornecedor()
    }, [attributes?.fornecedor])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- GRUPO DESPESA -------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearGrupoDespSelecionada = useCallback(() => {
        const newGrupoDespList = [...attributes?.grupoDespesa || []]
        setGrupoDespList(newGrupoDespList)
        setIdGrupoDesp(0)
        setIdSubGrupoDesp(0)

        setVisibleSearchBoxGrupoDespesa(false)
        boxFocusSubGrupoDespesa() // geralmente era pra ficar no boxFocusGrupoDespesa() mas como o subgrupoDespesa fica desabilitado e tive que alterar assim para a logica fazer sentido
    }, [attributes?.grupoDespesa])

    const handleFilterGrupoDespClick = useCallback(async (description: string) => {

        if (description === "") {

            const newGrupoDespList = [...attributes?.grupoDespesa || []]
            setGrupoDespList(newGrupoDespList || [])

        } else {

            const newGrupoDespList = [...attributes?.grupoDespesa || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setGrupoDespList(newGrupoDespList || [])
        }

    }, [attributes?.grupoDespesa])

    const handleGrupoDespSelectClick = useCallback((v: GrupoDespesaSearchBox) => {

        if (v) {
            const newGrupoDespList = [...attributes?.grupoDespesa || []]
            setGrupoDespList(newGrupoDespList)
            setIdGrupoDesp(v.id)
        }

        setVisibleSearchBoxGrupoDespesa(false)
        boxFocusGrupoDespesa()
    }, [attributes?.grupoDespesa])


    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- SUBGRUPO DESPESA -------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearSubGrupoDespSelecionada = useCallback(() => {
        const newSubGrupoDespList = [...attributes?.subGrupoDespesa || []]
        setSubGrupoDespList(newSubGrupoDespList)
        setIdSubGrupoDesp(0)

        setVisibleSearchBoxSubGrupoDespesa(false)
        boxFocusSubGrupoDespesa()

    }, [attributes?.subGrupoDespesa, grupoDespList])

    const handleFilterSubGrupoDespClick = useCallback((description: string) => {

        if (description === "") {

            const newSubGrupoDespList = [...attributes?.subGrupoDespesa || []]
            setSubGrupoDespList(newSubGrupoDespList)

        } else {

            const newSubGrupoDespList = [...attributes?.subGrupoDespesa || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setSubGrupoDespList(newSubGrupoDespList)
        }
    }, [attributes?.subGrupoDespesa, grupoDespList])

    const handleSubGrupoDespSelectClick = useCallback((v: SubGrupoDespesaSearchBox) => {

        if (v) {
            const newSubGrupoDespList = [...attributes?.subGrupoDespesa || []]
            setSubGrupoDespList(newSubGrupoDespList)
            setIdSubGrupoDesp(v.id)
        }

        setVisibleSearchBoxSubGrupoDespesa(false)
        boxFocusSubGrupoDespesa()

    }, [attributes?.subGrupoDespesa, grupoDespList])


    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- DUPLICATA PAGAR ------------------------------------------------------------------ ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const novoDupPagar = () => {
        setId(0)
        setNumDoc("")
        setSerie("")
        setValor("")
        setIdFornecedor(0)
        setIdGrupoDesp(0)
        setIdSubGrupoDesp(0)
        setDtVencimento("")
        setObservacao("")

        setUserCriador("")
        setDtCriador("")
        setUsertAtt("")
        setDtAtt("")

        Inputfocus()
        handleInputFocus()

        if (messageType === "DANGER") {
            setVisible(false)
        }

    }

    const handleSalvarDupPagar = async () => {

        setVisible(false)
        setLoading(true)

        try {

            handleInputFocus()

            const DuplicataPagar: any = {

                id: id,
                id_fornecedor: idFornecedor,
                dt_vencimento: dtVencimento,
                valor: valor,
                num_doc: numDoc,
                serie: serie,
                observacao: observacao,
                id_grupo_despesa: idGrupoDesp,
                id_sgrupo_despesa: idSubGrupoDesp,
            }

            const resp = await ContaAPagarService.Save(DuplicataPagar)

            if (resp.error) {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(resp.msg || '')

            } else {

                setVisible(true)
                setMessageType("SUCCESS")
                setId(resp.id || 0)
                setMessage(id > 0 ? "Dados da duplicata atualizados com sucesso." : "Dados da duplicata salvos com sucesso.")

                if (resp.dt_cadastro) {
                    const dataFormatadaCriacao = moment(resp.dt_cadastro).format('DD/MM/YYYY HH:mm')
                    setDtCriador(dataFormatadaCriacao)
                }

                if (resp.dt_last_update) {
                    const dataFormatadaAtt = moment(resp.dt_last_update).format('DD/MM/YYYY HH:mm')
                    setDtAtt(dataFormatadaAtt)
                }

                setNumDocCopia(resp.data.duplicata.num_doc)
                setUserCriador(resp.name_user_insert || '')
                setUsertAtt(resp.name_user_last_update || '')
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(id > 0 ? "Não foi possível atualizar os dados da duplicata. Por favor, tente novamente." : "Não foi possível salvar os dados da duplicata. Por favor, tente novamente.")

        } finally {
            setLoading(false)
            Inputfocus()
        }
    }

    const Inputfocus = () => {
        const inputElement = document.getElementById("num_doc")
        inputElement?.focus()
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- FOCUS ABA 1 ---------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const inputsRefs: InputsRefs = {
        numDuplicata: useRef(null),
        serie: useRef(null),
        valor: useRef(null),
        fornecedor: useRef(null),
        grupoDespesa: useRef(null),
        subgrupoDespesa: useRef(null),
        dataEmissao: useRef(null),
        dataVencimento: useRef(null),
        observacao: useRef(null),
    }

    const handleTabPress = (event: any, inputKey: any) => {

        if (event.key === 'Tab' && tabs[0].active) {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            handleInputFocus()

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefs)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length;

                const nextEl = inputsRefs[keys[nextIndex]].current;

                if (!nextEl) continue;
                if (nextEl.disabled) continue;
                if (nextEl.tabIndex === -1) continue;
                if (nextEl.offsetParent === null) continue; // está invisível (ex: display: none)

                break;
            } while (nextIndex !== currentIndex);

            if (nextIndex === 3) {
                setVisibleSearchBoxFornecedor(true)
                inputFocusFornecedor()
            }

            if (nextIndex === 4) {
                setVisibleSearchBoxGrupoDespesa(true)
                inputFocusGrupoDesp()
            }

            if (nextIndex === 5 && idGrupoDesp > 0) {
                console.log("aki1")
                setVisibleSearchBoxSubGrupoDespesa(true)
                inputFocusSubGrupoDesp()
            }

            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            const nextRef = inputsRefs[keys[nextIndex]].current;
            if (nextRef && typeof nextRef.focus === 'function') {
                nextRef.focus();
            }
        }
    }

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {

            if (event.key === 'Tab' && tabs[0].active) {

                event.preventDefault()

                const inputSearchForn = document.getElementById('inputSearchBox-fornecedor') as HTMLInputElement
                const inputSearchGrupoDesp = document.getElementById('inputSearchBox-grupoDespesa') as HTMLInputElement
                const inputSearchSubGrupoDesp = document.getElementById('inputSearchBox-subgrupoDespesa') as HTMLInputElement

                if (document.activeElement === inputSearchForn) {

                    clickSearchBoxGrupoDespesa()
                    setVisibleSearchBoxFornecedor(false)

                } else if (document.activeElement === inputSearchGrupoDesp && idGrupoDesp === 0) {

                    console.log("aki3")
                    inputsRefs['dataVencimento'].current?.focus()
                    setVisibleSearchBoxGrupoDespesa(false)

                } else if (document.activeElement === inputSearchGrupoDesp) {

                    console.log("aki4")
                    clickSearchBoxSubGrupoDespesa()
                    setVisibleSearchBoxGrupoDespesa(false)

                } else if (document.activeElement === inputSearchSubGrupoDesp) {

                    console.log("aki5")
                    inputsRefs['dataVencimento'].current?.focus()
                    setVisibleSearchBoxSubGrupoDespesa(false)

                }

            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [tabs, idGrupoDesp])

    const handleInputFocus = () => {
        setVisibleSearchBoxFornecedor(false)
        setVisibleSearchBoxGrupoDespesa(false)
        setVisibleSearchBoxSubGrupoDespesa(false)
    }

    // FORNECEDOR -------------------------------------------------
    const boxFocusFornecedor = () => {
        // Move o foco para o input correspondente à chave 'fornecedor'.
        inputsRefs['fornecedor'].current?.focus()
    }

    const clickSearchBoxFornecedor = useCallback(() => {
        setVisibleSearchBoxFornecedor((prevState) => {
            const newState = !prevState; // Alterna o estado atual
            if (newState) {
                // Fecha o SearchBoxGrupoDespesa e foca no SearchBoxFornecedor
                setVisibleSearchBoxGrupoDespesa(false);
                inputFocusFornecedor();
            }
            return newState;
        });
        boxFocusFornecedor(); // Mantém fora do estado para ser executado independentemente
    }, [])

    const inputFocusFornecedor = () => {
        let inputSearch = document.getElementById(`inputSearchBox-fornecedor`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // GRUPO DESPESA -------------------------------------------------
    const boxFocusGrupoDespesa = () => {
        // Move o foco para o input correspondente à chave 'grupoDespesa'.
        inputsRefs['grupoDespesa'].current?.focus()
    }

    const clickSearchBoxGrupoDespesa = useCallback(() => {
        setVisibleSearchBoxGrupoDespesa((prevState) => {
            const newState = !prevState; // Alterna o estado atual
            if (newState) {
                // Fecha o SearchBoxFornecedor e foca no SearchBoxGrupoDesp
                setVisibleSearchBoxFornecedor(false);
                inputFocusGrupoDesp();
            }
            return newState;
        });
        boxFocusGrupoDespesa(); // Mantém fora do estado para ser executado independentemente
    }, [])

    const inputFocusGrupoDesp = () => {
        let inputSearch = document.getElementById(`inputSearchBox-grupoDespesa`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // SUBGRUPO DESPESA -------------------------------------------------
    const boxFocusSubGrupoDespesa = () => {
        // Move o foco para o input correspondente à chave 'grupoDespesa'.
        inputsRefs['subgrupoDespesa'].current?.focus()
    }

    const clickSearchBoxSubGrupoDespesa = useCallback(() => {
        setVisibleSearchBoxSubGrupoDespesa((prevState) => {
            const newState = !prevState; // Alterna o estado atual
            if (newState) {
                // Fecha o SearchBoxFornecedor e foca no SearchBoxGrupoDesp
                setVisibleSearchBoxFornecedor(false);
                setVisibleSearchBoxGrupoDespesa(false);
                inputFocusSubGrupoDesp();
            }
            return newState;
        });
        boxFocusSubGrupoDespesa(); // Mantém fora do estado para ser executado independentemente
    }, [])

    const inputFocusSubGrupoDesp = () => {
        let inputSearch = document.getElementById(`inputSearchBox-subgrupoDespesa`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- FOCUS ABA 2 ---------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleTabPressNone = (event: any) => {

        if (event.key === 'Tab' && tabs[1].active) {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleTabPressNone)

        return () => {

            document.removeEventListener('keydown', handleTabPressNone)
        }

    }, [tabs])



    const btNovoVisible = parseInt(idDupPagar || '') > 0 ? 'invisible hidden' : 'visible'

    return (
        <Template isLoading={loading} >

            <div className={`${classDivBackground}`}>

                <div id="div-body" role='button' className={`${classDivBody}`}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`bg-white dark:bg-slate-600 border border-slate-300 dark:border-slate-800 shadow-md shadow-indigo-200 dark:shadow-slate-800 rounded-lg`}>

                        <div className={`h-[50px] w-full flex items-center my-3 px-2`}>
                            <FcNook className={`mr-2 ml-2 text-slate-700 dark:text-slate-200`} size="25px" />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200 break-all mx-2`}>{parseInt(idDupPagar || '') || id > 0 ? `Editar - Duplicatas a Pagar - ${numDocCopia || ''}` : `Cadastro - Duplicatas a Pagar`}</span>

                            <button onClick={() => { setModalTutorialVisible(true) }} tabIndex={-1} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt} shadow-md shadow-blue-600`}  >
                                <FaVideo />
                                <span className='mx-1'>Tutorial</span>
                            </button>
                        </div>

                        <div className={`w-full h-full`}>

                            <div className={`h-[60px] flex overflow-x-auto scrollable_horizontal border border-slate-200 dark:border-slate-700`}>
                                {tabs.map((item) => {
                                    return (
                                        <button tabIndex={-1} onClick={() => handleChangeTab(item.index)} key={item.index.toString()}
                                            className={`px-4 font-mono font-bold w-[180px]
                                                ${item.active ?
                                                    `hover:text-sky-500 text-sky-600 border border-b-[3px] border-l-0 border-t-0 border-r-slate-300 border-b-sky-600 dark:text-slate-200 dark:border-r-slate-700 dark:border-b-slate-300` :
                                                    `text-sky-600 dark:text-slate-300 bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 border border-l-0 border-t-0 border-b-0 dark:border-slate-800`
                                                } `}>
                                            <div tabIndex={-1} className={`flex items-center`}>
                                                <span className={`mr-2`}><Icone icon={item.icon} /></span>
                                                <span className={`text-sm roboto whitespace-nowrap`}>{item.titulo}</span>
                                            </div>
                                        </button>
                                    )
                                })}
                            </div>

                            <div className={`${tabs[0].active ? `block` : `hidden`} relative`}>

                                <div className={`w-full h-full grid gap-5 grid-cols-12 p-4`}>

                                    <div className={`relative col-span-12 space-y-1`}>
                                        <div className={`flex flex-row `}>
                                            <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300  mr-2`}>Dados da Duplicata</span>
                                            <FaRegQuestionCircle data-tooltip-id={'tooltip-btn-question'} id={'btn-question'} className={`text-[#ACACAC] dark:text-slate-300 cursor-pointer`} size={18} />
                                            <Tooltip id={'tooltip-btn-question'} anchorSelect={'#btn-question'} positionStrategy="fixed" place='top' >
                                                <span >Os campos com borda <br /> vermelha são obrigatórios</span>
                                            </Tooltip>
                                        </div>

                                        <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input ref={inputsRefs.numDuplicata} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'numDuplicata')} id="num_doc" className={`${classInput} ${classInputDark}`} type='text' inputMode='text' maxLength={40} autoComplete="off" placeholder=' ' value={numDoc} onFocus={handleInputFocus} onChange={handleChangeNumDoc} />
                                        <label htmlFor="num_doc" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Num. Duplicata</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input ref={inputsRefs.serie} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'serie')} id="serie" className={`${classInput} ${classInputDark}`} type='text' inputMode='numeric' autoComplete="off" placeholder=' ' value={serie} onFocus={handleInputFocus} onChange={handleChangeSerie} />
                                        <label htmlFor="serie" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Série</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                                        <div className={`${barraVermelhoAzul} ${parseFloat(valor) > 0 ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.valor} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'valor')} id="valor" className={`${classInput} ${classInputDark} ${parseFloat(valor) > 0 ? '' : focusRed}`} type='text' inputMode='numeric' autoComplete="off" placeholder=' ' value={valor} onFocus={handleInputFocus} onChange={handleChangeValor} />
                                        <label htmlFor="valor" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${parseFloat(valor) > 0 ? '' : focusLabelRed}`}>Valor (R$)</label>
                                    </div>

                                    <div className={`relative col-span-12 xl:col-span-6`}>

                                        <div ref={inputsRefs['fornecedor']} tabIndex={0} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'fornecedor')} />
                                        <div className={`${barraVermelhoAzul} ${idFornecedor > 0 ? bgBlue : bgRed}`} />
                                        <SearchBox
                                            dataList={fornecedorList}
                                            idRegistro={idFornecedor || undefined}
                                            label='Fornecedor'
                                            componentId='fornecedor'
                                            borda={true}
                                            visibleTAB={visibleSearchBoxFornecedor}
                                            setDataClick={handleFornecedorSelectClick}
                                            clearDataClick={handleClearFornecedorSelecionada}
                                            filterDataClick={handleFilterFornecedorClick}
                                            clicado={clickSearchBoxFornecedor}
                                        />
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-6 xl:col-span-4`}>

                                        <div ref={inputsRefs['grupoDespesa']} tabIndex={0} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'grupoDespesa')} />
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <SearchBox
                                            dataList={grupoDespList}
                                            idRegistro={idGrupoDesp || undefined}
                                            label='Grupo de Despesa'
                                            componentId='grupoDespesa'
                                            visibleTAB={visibleSearchBoxGrupoDespesa}
                                            setDataClick={handleGrupoDespSelectClick}
                                            clearDataClick={handleClearGrupoDespSelecionada}
                                            filterDataClick={handleFilterGrupoDespClick}
                                            clicado={clickSearchBoxGrupoDespesa}
                                        />
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-6 xl:col-span-4`}>

                                        <div ref={inputsRefs['subgrupoDespesa']} tabIndex={0} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'subgrupoDespesa')} />
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <SearchBox
                                            dataList={subGrupoDespList}
                                            idRegistro={idSubGrupoDesp}
                                            disabled={idGrupoDesp === 0}
                                            label='SubGrupo de Despesa'
                                            componentId='subgrupoDespesa'
                                            visibleTAB={visibleSearchBoxSubGrupoDespesa}
                                            setDataClick={handleSubGrupoDespSelectClick}
                                            clearDataClick={handleClearSubGrupoDespSelecionada}
                                            filterDataClick={handleFilterSubGrupoDespClick}
                                            clicado={clickSearchBoxSubGrupoDespesa}
                                        />
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-6 xl:col-span-2`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input ref={inputsRefs.dataEmissao} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'dataEmissao')} id="dt_liquidacao" className={`${classInput} ${classInputDark} dark:[color-scheme:dark] cursor-not-allowed`} type='date' min="1900-01-01" max="9999-12-31" autoComplete="off" placeholder=" " disabled={true} value={dtEmissao} onFocus={handleInputFocus} onChange={handleChangeDtEmissao} />
                                        <label htmlFor="dt_liquidacao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Data Emissão</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-6 xl:col-span-2`}>
                                        <div className={`${barraVermelhoAzul} ${dtVencimento != '' ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.dataVencimento} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'dataVencimento')} id="dt_vencimento" className={`${classInput} ${classInputDark} ${dtVencimento != '' ? '' : focusRed} ${dtVencimento === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark] `} type="date" min="1900-01-01" max="9999-12-31" autoComplete="off" placeholder=" " value={dtVencimento} onFocus={handleInputFocus} onChange={handleChangeDtVencimento} />
                                        <label htmlFor="dt_vencimento" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${dtVencimento != '' ? '' : focusLabelRed}`}>Data Vencimento</label>
                                    </div>

                                    <div className={`relative col-span-12`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue} bottom-1 dark:bottom-1`} />
                                        <textarea ref={inputsRefs.observacao} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'observacao')} id="obs" className={`${classInput} ${classInputDark} min-h-[160px] lg:min-h-[120px] resize-none`} autoComplete="off" value={observacao} onFocus={handleInputFocus} onChange={handleChangeObs} />
                                        <label htmlFor="obs" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Observação</label>
                                    </div>

                                </div>

                                <div className={`flex flex-col space-y-3 m-4 sm:space-y-0 sm:space-x-4 sm:flex-row sm:justify-end`}>

                                    <Link tabIndex={-1} onMouseUp={handleMouseUp} to="/contaApagar" className={`${classbtColunasVermelho} ${classWeigthBt}`}>
                                        <BsBoxArrowInLeft size="20px" className='mr-[5px]' /> Voltar
                                    </Link>

                                    <button tabIndex={-1} onClick={novoDupPagar} className={`${classBt} ${classbtCinzaClaro} ${btNovoVisible} ${classWeigthBt}`}>
                                        <AiOutlineClear size="20px" className='mr-[5px]' /> Limpar Campos
                                    </button>

                                    <button tabIndex={-1} onFocus={handleInputFocus} onClick={handleSalvarDupPagar} className={`${classBt} ${classbtAzul} ${classWeigthBt}`}>
                                        {!loading && <IoSave size="16px" className='mr-[5px]' />}
                                        {loading &&
                                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                            </div>
                                        }
                                        {parseInt(idDupPagar || '0') > 0 || id != 0 ? !loading ? `Atualizar` : `Aguarde` : !loading ? `Salvar` : `Aguarde`}

                                    </button>
                                </div>

                            </div>

                            <div className={`${tabs[1].active ? 'block' : 'hidden'} relative h-[400px] sm:h-[200px]`}>

                                <div className={`w-full h-full flex flex-row p-4`}>

                                    <div className={`w-full grid grid-cols-12`}>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="userCriacaoDupPag" className={`${classUserCriarAtt}`}>Criador</label>
                                            <span id="userCriacaoDupPag" className={`${classDtCriarAtt}`}>{userCriador}</span>
                                        </div>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="dtCriacaoDupPag" className={`${classUserCriarAtt}`}>Data de Criação</label>
                                            <span id="dtCriacaoDupPag" className={`${classDtCriarAtt}`}>{dtCriador}</span>
                                        </div>

                                    </div>

                                    <div className={`w-full grid grid-cols-12`}>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="userAttDupPag" className={`${classUserCriarAtt}`}>Atualizador</label>
                                            <span id="userAttDupPag" className={`${classDtCriarAtt}`}>{usertAtt}</span>
                                        </div>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="dtAttDupPag" className={`${classUserCriarAtt}`}>Data de Atualização</label>
                                            <span id="dtAttDupPag" className={`${classDtCriarAtt}`}>{dtAtt}</span>
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                    {modalTutorialVisible &&
                        <ModalTutorial
                            linkVideo='/tutorial_dupPagar.mp4'
                            title='Tutorial sobre duplicatas a pagar'
                            visible={modalTutorialVisible}
                            onCloseClick={() => setModalTutorialVisible(false)}
                        />
                    }

                </div>

            </div>

        </Template>
    )
}